import TouchableRipple from './TouchableRipple';

export default TouchableRipple;
export { TouchableRipple };
